import { connect } from 'react-redux';
import Navigation from './Navigation';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  id: state.investments.id,
  name: state.investments.name,
  link: state.investments.projectPage
});

export default connect(mapStateToProps)(Navigation);
